import { parse, parseISO } from 'date-fns'
import DataStore from '../State/DataStore'
import LayoutStore from '../State/LayoutStore'
import SessionStore from '../State/SessionStore'
import { makeRequest } from './makeRequest'
import { router } from '../App'

export const beginAccountingOauth = async (
    accountingSystem = SessionStore.organisation.accountingSystem
) => {
    await DataStore.startSave()
    accountingSystem ??= SessionStore.organisation.accountingSystem

    // Helper to safely check if modal parameter equals a specific value
    const hasModalParam = (modalName) => {
        const searchParams = new URLSearchParams(
            typeof router.latestLocation?.search === 'string'
                ? router.latestLocation.search
                : ''
        )
        return searchParams.get('modal') === modalName
    }

    // Determine the state query parameter based on modal
    let stateQueryParam = ''
    if (
        LayoutStore.modals.has('invoice-settings') ||
        hasModalParam('invoice-settings')
    ) {
        stateQueryParam = '?modal=invoice-settings'
    } else if (
        LayoutStore.modals.has('import-one-contact') ||
        hasModalParam('import-one-contact')
    ) {
        stateQueryParam = '?modal=import-one-contact'
    } else if (
        LayoutStore.modals.has('import-contacts') ||
        hasModalParam('import-contacts')
    ) {
        stateQueryParam = '?modal=import-contacts'
    }

    let r = await makeRequest({
        path: `api/v1.5/accounting/redirect`,
        method: 'post',
        data: {
            accountingSystem,
            timezoneOffset: -1 * new Date().getTimezoneOffset(),
            redirectUri: `${process.env.REACT_APP_CLIENT_URL}/accounting/auth`,
            state: router.latestLocation.pathname + stateQueryParam,
        },
    })
    window.location.href = r?.data?.url
}

export const connectAccountingOauth = async (
    accountingSystem = SessionStore.organisation.accountingSystem
) => {
    let r = await makeRequest({
        path: `api/v1.5/accounting/connect`,
        method: 'post',
        data: {
            accountingSystem,
            redirectUri: `${process.env.REACT_APP_CLIENT_URL}/accounting/auth`,
            ...router.latestLocation?.search,
        },
    })
    if (r?.data?.expiresAt) {
        await SessionStore.saveAccountingExpires(parseISO(r.data.expiresAt))
    }
}

export const syncInvoiceToAccounting = async (
    invoice,
    accountingSystem = SessionStore.organisation.accountingSystem
) => {
    const lineItemDescriptions = {}
    invoice.lineItems.forEach((li) => {
        lineItemDescriptions[li.id] = li.formattedDescription
    })
    let r = await makeRequest({
        path: `api/v1.5/accounting/sync`,
        method: 'post',
        data: {
            accountingSystem,
            redirectUri: `${process.env.REACT_APP_CLIENT_URL}/accounting/auth`,
            invoiceId: invoice.id,
            lineItemDescriptions,
        },
    })
    invoice.accountingSystemId = SessionStore.organisation.accountingSystem
    invoice.accountingSystemInvoiceId =
        r?.data?.accountingSystemInvoiceId || invoice.accountingSystemInvoiceId
}

export const fetchAccountingSettings = async (
    accountingSystem = SessionStore.organisation.accountingSystem
) => {
    let r = await makeRequest({
        path: `api/v1.5/accounting/settings`,
        method: 'post',
        data: {
            accountingSystem,
            redirectUri: `${process.env.REACT_APP_CLIENT_URL}/accounting/auth`,
        },
    })
    SessionStore.organisation.updateAccountingSystemSettings({ data: r?.data })
    return r?.data
}

export const fetchAccountingContacts = async (
    accountingSystem = SessionStore.organisation.accountingSystem
) => {
    let r = await makeRequest({
        path: `api/v1.5/accounting/contacts`,
        method: 'post',
        data: {
            accountingSystem,
            redirectUri: `${process.env.REACT_APP_CLIENT_URL}/accounting/auth`,
        },
    })
    return r?.data
}
